/**
 * User: herbert
 * Date: 20.04.16
 * Time: 16:43
 */

/*eslint smells/no-complex-switch-case: 0 */

import React from 'react';
//import ReactDOM from 'react-dom';
import Reflux from 'reflux';

import steleStore from '../stores/stele-store.js';
import StelePart from '../StelePart.js';

import * as config from '../../../config.js';

import mapParts from './for-stele/parts.jsx';


export default React.createClass({
	mixins: [
		Reflux.connect(steleStore, 'data'), // this.state.data entspricht parameter von trigger() bei output: des stores,
	                                      // hier: ein Array mit StelePart-Elementen
	],
	render: function() {
		const activeStele = this.state.data.active.slice();

		if(activeStele.length > 0) {
			switch (activeStele[0].name) {
				case config.PART_MODUL_WEGE_NAME:
				case config.PART_MODUL_WEGE2_NAME:
					// intentionally left blank
					break;
				default:
					activeStele.unshift(new StelePart(config.PART_DECKEL));
			}
		} else {
			activeStele.unshift(new StelePart(config.PART_DECKEL));
		}

		// wir kopieren die Stele und ersetzen die Teilenamen, wenn aufgrund der Teil-Options ein anderes als das Standardbild des Teils angezeigt wird
		/**
		 * @see config.PART_MODUL_AUFNAHME_250_COVER_NAME
		 * @see config.PART_MODUL_AUFNAHME_500_COVER_NAME
		 * @see config.PART_MODUL_AUFNAHME_1000_COVER_NAME
		 * @see config.PART_MODUL_AUFNAHME_1500_COVER_NAME
		 */
		activeStele.forEach( (part, i) => {
			// part is read-only, only write to activeStele[i] after clone
			if(part.container) {
				activeStele[i] = Object.assign({}, activeStele[i]);
				activeStele[i].children = activeStele[i].children.slice();

				if(activeStele[i].backCover)
					activeStele[i].name = activeStele[i].name + '-cover';

				activeStele[i].children.forEach( (child, j) => {
					if(child.name === config.PART_ELEMENT_FASSADE_500_NAME) {
						// rember: activeStele[i] got cloned just above
						activeStele[i].children[j] = Object.assign({}, activeStele[i].children[j]);
						activeStele[i].children[j].name = activeStele[i].children[j].name + '-' + child.horiz;
					}
				});
			}
		});

		activeStele.push(new StelePart(config.PART_BASIS));

		if(this.state.data.charging.count > 0) {
			activeStele.push({name: config.PART_MODUL_CHARGING_NAME + this.state.data.charging.count});
		} else {
			activeStele.push({name: config.PART_MODUL_BASEPLATE_NAME});
		}


		const fuellung = this.state.data !== null ? mapParts(activeStele, 0, null, 0, undefined, undefined, true) : null;

		return (<div className="slx-stele-zoom">
					<div className="slx-stele-zoom_headroom" />
					<div className="slx-stele-zoom_headroom" />
					{/* FIXME ggf. Deckel als reguläres img
					     src={zoom ? config.zoomPath + '!!!TODO' : steleSVG.getStele(steleHeight, size, (this.props.renderHeight ? this.state.data.height : null), this.props.datasheet)} />*/}
					{fuellung}
					{/*<div className="slx-stele-zoom_headroom" />*/}
			</div>);
	}
});
